import Vue from 'vue'
import iView from 'iview'
import 'iview/dist/styles/iview.css'
import config from '@/config'
const { iViewConfig } = config

Vue.use(iView, iViewConfig)
